import { useEffect, useLayoutEffect, useState, type RefObject } from 'react'

/** Телефон: строки чека карточками, итог и оплата — у нижнего края (план UI-IA 5.3). */
const PHONE_QUERY = '(max-width: 600px)'

function phoneNow(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(PHONE_QUERY).matches
}

/** Узкий экран телефона; среда без `matchMedia` (тесты) — не телефон. */
export function useNarrow(): boolean {
  const [narrow, setNarrow] = useState(phoneNow)
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined
    const query = window.matchMedia(PHONE_QUERY)
    const update = () => setNarrow(query.matches)
    query.addEventListener('change', update)
    return () => query.removeEventListener('change', update)
  }, [])
  return narrow
}

/** Нижний запас под экраном продажи: поле окна или страницы под ним. */
const BOTTOM_GAP = 32

/**
 * Экран продажи — до нижнего края окна и без прокрутки страницы (как в старом
 * РМК): высота считается от того, где экран начинается. Над ним может стоять
 * полоса вкладок раздела или рамка модального окна — их высоту экран не
 * знает, поэтому меряет своё положение, а не вычитает чужие размеры.
 */
export function useFillHeight(ref: RefObject<HTMLElement | null>, enabled: boolean): void {
  useLayoutEffect(() => {
    const element = ref.current
    if (element === null) return
    if (!enabled) {
      element.style.removeProperty('--rmk-fill')
      return
    }
    const top = element.getBoundingClientRect().top
    const height = Math.max(420, Math.floor(window.innerHeight - top - BOTTOM_GAP))
    element.style.setProperty('--rmk-fill', `${height}px`)
  })
  useEffect(() => {
    if (!enabled) return undefined
    const element = ref.current
    const update = () => {
      if (element === null) return
      const top = element.getBoundingClientRect().top
      element.style.setProperty('--rmk-fill', `${Math.max(420, Math.floor(window.innerHeight - top - BOTTOM_GAP))}px`)
    }
    window.addEventListener('resize', update)
    return () => window.removeEventListener('resize', update)
  }, [enabled, ref])
}
